import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const PublicLayout = ({ children }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                minHeight: '100vh',
                width: '100vw',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                overflow: 'hidden',
                background: theme.palette.mode === 'dark' 
                    ? 'radial-gradient(circle at 50% 50%, #1a1b4b 0%, #0a0b2a 100%)' 
                    : 'radial-gradient(circle at 50% 50%, #f0f4f8 0%, #ffffff 100%)',
            }}
        >
            {/* Animated Glow Effects */}
            <Box
                sx={{
                    position: 'absolute',
                    top: '-20%',
                    left: '-20%',
                    width: '60%',
                    height: '60%',
                    borderRadius: '50%',
                    background: theme.palette.mode === 'dark' 
                        ? 'radial-gradient(circle, rgba(0, 212, 255, 0.15) 0%, transparent 70%)' 
                        : 'radial-gradient(circle, rgba(0, 212, 255, 0.1) 0%, transparent 70%)',
                    filter: 'blur(60px)',
                    zIndex: 0,
                    animation: 'float 10s infinite ease-in-out',
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    bottom: '-20%',
                    right: '-20%',
                    width: '60%',
                    height: '60%',
                    borderRadius: '50%',
                    background: theme.palette.mode === 'dark' 
                        ? 'radial-gradient(circle, rgba(176, 38, 255, 0.15) 0%, transparent 70%)' 
                        : 'radial-gradient(circle, rgba(139, 92, 246, 0.1) 0%, transparent 70%)',
                    filter: 'blur(60px)',
                    zIndex: 0,
                    animation: 'float 15s infinite ease-in-out reverse',
                }}
            />

            {/* Main Content */}
            <Box sx={{ position: 'relative', zIndex: 1, width: '100%', maxWidth: '500px', p: 2 }}>
                {children}
            </Box>

            {/* Footer */}
            <Box sx={{ position: 'absolute', bottom: 20, zIndex: 1, color: theme.palette.text.secondary }}>
                <Typography variant="caption">
                    © {new Date().getFullYear()} Trendify Ads. All rights reserved.
                </Typography>
            </Box>

            <style>
                {`
                    @keyframes float {
                        0% { transform: translate(0, 0); }
                        50% { transform: translate(30px, 30px); }
                        100% { transform: translate(0, 0); }
                    }
                `}
            </style>
        </Box>
    );
};

export default PublicLayout;
